import script from "./fr.vue?vue&type=script&lang=js"
export * from "./fr.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/languages/fr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19f9b888"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19f9b888', __exports__)) {
    api.reload('19f9b888', __exports__)
  }
  
}


export default __exports__